import styles from './DepositModal.module.css';
import axios from 'axios';

const DepositModal = ({ deposit, onClose, onReject }) => {
  if (!deposit) return null;

  const handleReject = async () => {
    try {
      await axios.put(`/api/admin/deposit/${deposit.id}/reject`, {}, { withCredentials: true });
      onReject(deposit.id);
      onClose();
    } catch (error) {
      console.error('Failed to reject deposit:', error);
      alert('Error rejecting deposit.');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Deposit Details</h2>
        <ul className={styles.detailList}>
          <li><strong>ID:</strong> {deposit.id}</li>
          <li><strong>Sub UID:</strong> {deposit.sub_uid}</li>
          <li><strong>Amount:</strong> {deposit.amount}</li>
          <li><strong>Status:</strong> {deposit.status}</li>
          <li><strong>Coin:</strong> {deposit.coin_symbol}</li>
          <li><strong>Chain:</strong> {deposit.chain}</li>
          <li><strong>From:</strong> {deposit.from_address}</li>
          <li><strong>To:</strong> {deposit.to_address}</li>
          <li><strong>Created At:</strong> {new Date(deposit.created_at).toLocaleString()}</li>
        </ul>

        <div className={styles.actions}>
          <button onClick={onClose}>Close</button>
          {deposit.status === 'pending' && (
            <button className={styles.reject} onClick={handleReject}>Reject</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepositModal;
